import { render, staticRenderFns } from "./CrearDescuento.vue?vue&type=template&id=a94ea5d0&scoped=true&"
import script from "./CrearDescuento.vue?vue&type=script&lang=js&"
export * from "./CrearDescuento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94ea5d0",
  null
  
)

export default component.exports